import React, { Component } from 'react';
import FormItem from '../../components/FormItem/index';
import { Form, Input, Button, message, Checkbox } from 'antd';
import PreviewUploadComponent from '../../components/Upload/previewImg';
import MultipleUploadComponent from '../../components/Upload/multipleImg';
import services from '../../services/api';

const { TextArea } = Input;
// const RadioGroup = Radio.Group;
class AlbumAdd extends Component {
  constructor() {
    super();
    this.state = {
      detail: {},
      loaded: false
    };
    this.actionType = 'add';
    this.type = '';
    this.id = '';
  }

  componentDidMount() {
    if (this.props.actionType) {
      this.actionType = this.props.actionType;
    } else {
      if (this.props.location.pathname.indexOf('edit') !== -1) {
        this.actionType = 'update';
        this.id = this.props.match.params.id;
        this.getDetail();
      }
      this.type = this.props.match.params.type;
    }
  }

  /**获取详情 */
  getDetail = () => {
    services.album.queryOne({ id: this.id }).then(data => {
      if (data.code === 0) {
        this.setState({
          detail: data.data
        });
        this.props.form.setFieldsValue({
          title: data.data.title,
          click_num: data.data.click_num,
          des: data.data.des,
          is_top: data.data.is_top,
          orders: data.data.orders,
          preview_image: { fileUrl: data.data.preview_image },
          images: { fileUrl: data.data.images }
        });
        this.setState({
          loaded: true
        });
      } else {
        message.error(data.msg);
      }
    });
  };

  /** 获取到列表url  */
  getListUrl = () => {
    const addUrlReg = /.+(?=\/add)/;
    const editUrlReg = /.+(?=\/\d+\/edit)/;
    if (this.props.location.pathname.match(addUrlReg) !== null) {
      return this.props.location.pathname.match(addUrlReg)[0];
    }
    if (this.props.location.pathname.match(editUrlReg) !== null) {
      return this.props.location.pathname.match(editUrlReg)[0];
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      const params = {
        ...values,
        type: this.type,
        is_top: values.is_top ? 1 : 0,
        click_num: values.click_num ? parseInt(values.click_num, 10) : 0,
        orders: values.orders ? parseInt(values.orders, 10) : 999,
        preview_image: values.preview_image.fileUrl,
        images: values.images.fileUrl
      };
      if (this.actionType === 'update') {
        params.id = this.id;
      }
      if (!err) {
        services.album[this.actionType](params).then(data => {
          if (data.code === 0) {
            message.success(data.msg);
            this.props.history.push(this.getListUrl());
          } else {
            message.error(data.msg);
          }
        });
      }
    });
  };
  checkImagesRequire = (rule, value, callback) => {
    if (value.fileUrl) {
      callback();
      return;
    }
    callback('请上传相册');
  };
  checkPreviewRequire = (rule, value, callback) => {
    if (value.fileUrl) {
      callback();
      return;
    }
    callback('请上传缩略图');
  };

  render() {
    const formItems1 = [
      {
        label: {
          label: '名称',
          className: 'tantuer-form-item'
        },
        name: 'title',
        options: {
          initialValue: '',
          rules: [{ required: true, message: '请输入名称' }]
        },
        component: <Input placeholder="名称" className="large" />,
        children: [
          {
            name: 'is_top',
            options: {
              initialValue: ''
            },
            component: <Checkbox>置顶</Checkbox>
          }
        ]
      },

      {
        label: {
          label: '排序',
          className: 'tantuer-form-item'
        },
        name: 'orders',
        options: {
          initialValue: ''
        },
        component: (
          <Input placeholder="数字越小越靠前，默认999" className="default" />
        )
      },
      {
        label: {
          label: '点击量',
          className: 'tantuer-form-item'
        },
        name: 'click_num',
        options: {
          initialValue: ''
        },
        component: <Input placeholder="点击量" className="default" />
      },
      {
        label: {
          label: '描述',
          className: 'tantuer-form-item'
        },
        name: 'des',
        options: {
          initialValue: ''
        },
        component: <TextArea placeholder="描述" className="default" />
      }
    ];
    const formItems2 = [
      {
        label: {
          label: '缩略图',
          className: 'tantuer-form-item'
        },
        name: 'preview_image',
        options: {
          initialValue: { fileUrl: '' },
          rules: [{ required: true }, { validator: this.checkPreviewRequire }]
        },
        component: <PreviewUploadComponent />
      }
    ];
    const formItems3 = [
      {
        label: {
          label: '相册',
          className: 'tantuer-form-item'
        },
        name: 'images',
        options: {
          initialValue: { fileUrl: '' },
          rules: [{ required: true }, { validator: this.checkImagesRequire }]
        },
        component: (
          <MultipleUploadComponent
            loaded={this.state.loaded}
            actionType={this.actionType}
          />
        )
      }
    ];

    return (
      <div>
        <Form onSubmit={this.handleSubmit} className="login-form">
          <div className="tantuer-field-area">
            {formItems1.map(item => {
              return (
                <FormItem key={item.name} form={this.props.form} item={item} />
              );
            })}
          </div>
          <div className="tantuer-field-area">
            {formItems2.map(item => {
              return (
                <FormItem key={item.name} form={this.props.form} item={item} />
              );
            })}
          </div>
          <div className="tantuer-field-area">
            {formItems3.map(item => {
              return (
                <FormItem key={item.name} form={this.props.form} item={item} />
              );
            })}
          </div>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            提交
          </Button>
        </Form>
      </div>
    );
  }
}

export default Form.create()(AlbumAdd);
